import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = theme => ({
    dialog: {
        '& .MuiPaper-root':{
            margin: theme.spacing(1),
            width: 360,
            height: 210  
        }
    }
  });

class OpenSlot extends Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);

    }


    handleClickOpen = () => {
        this.props.onChange(true);
    };

    handleClose = () => {
        this.props.onChange(false);
    };

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Dialog className={classes.dialog}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirmação de abertura de Porta"}</DialogTitle>
                    <DialogContent> 
                        <div><p>Deseja realmente abrir a Porta?</p></div>
                    </DialogContent>
                    <DialogActions>
                    <div><Button onClick={this.handleClose} color="default">
                        Cancelar
                    </Button>
                    <Button onClick={this.handleClickOpen} color="primary" autoFocus>
                        Abrir
                    </Button></div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(useStyles)(OpenSlot);